import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';
import { useTranslation } from '../i18n';

const OrgContext = createContext({ orgName: 'VIK Tuzi', reloadOrgName: () => {} });

export function OrgProvider({ children }) {
  const [names, setNames] = useState({ me: 'VIK Tuzi', sq: '' });
  const { language } = useTranslation();

  const reloadOrgName = useCallback(async () => {
    try {
      const r = await api.get('/settings/public');
      setNames({
        me: r.data.org_name || 'VIK Tuzi',
        sq: r.data.org_name_sq || '',
      });
    } catch {
      // keep default
    }
  }, []);

  useEffect(() => { reloadOrgName(); }, [reloadOrgName]);

  const orgName = (language === 'sq' && names.sq) ? names.sq : names.me;

  useEffect(() => { document.title = orgName; }, [orgName]);

  return (
    <OrgContext.Provider value={{ orgName, reloadOrgName }}>
      {children}
    </OrgContext.Provider>
  );
}

export function useOrg() { return useContext(OrgContext); }
